import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import Panel from "./pages/PanelAdmin";
import PublicLayout from "./components/PublicLayout";

function App() {
  return (
    <Router>
      <Routes>
        {/* Rutas públicas */}
        <Route element={<PublicLayout />}>
          <Route index element={<Home />} />
          <Route path="panel" element={<Panel />} />
        </Route>
        {/* Ruta 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>

  );
}

export default App;
